import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { BuildType } from 'mbs-ui-shared@models';
import { OsType } from 'mbs-ui-shared@models/Computer';
import { FinishPath, OnboardingButtonState, OnboardingView } from 'wizards/onboarding/onboarding.constants';
import { OnboardingService } from 'wizards/services/onboarding/onboarding.service';
import { InstallationView } from 'wizards/steps/installation/installation.constants';

@UntilDestroy()
@Component({
  selector: 'mbs-onboarding-wizard-hyper-v-view',
  templateUrl: './hyper-v.component.html'
})
export class HyperVViewComponent implements OnInit {
  @Input() back: EventEmitter<Record<string, unknown>>;
  @Input() next: EventEmitter<Record<string, unknown>>;
  @Output() finish = new EventEmitter<string>();
  @Output() updateBackButton = new EventEmitter<Partial<OnboardingButtonState>>();
  @Output() updateNextButton = new EventEmitter<Partial<OnboardingButtonState>>();
  readonly viewMode = OnboardingView.HyperV;
  readonly installationView = InstallationView.HyperV;
  readonly buildsSelectionConfig = [
    {
      buildType: BuildType.VMware,
      os: OsType.windows
    }
  ];

  constructor(public onboardingService: OnboardingService, public i18NPipe: I18NextPipe) {}

  ngOnInit() {
    this.updateNextButton.emit({ text: this.i18NPipe.transform('wizards:onboarding.buttons.finish', { format: 'title' }) });

    this.initEvents();
  }

  public finishWizard(): void {
    this.onboardingService.stable$.next(false);
    this.finish.emit(FinishPath.Computers);
  }

  private initEvents(): void {
    const stable$ = this.onboardingService.stable$;

    stable$.pipe(untilDestroyed(this)).subscribe((stable) => {
      this.updateNextButton.emit({ visible: stable });
    });

    this.next.pipe(untilDestroyed(this)).subscribe(() => {
      this.finishWizard();
    });
  }
}
